<template>
    <div>
        <section class="problems border-0 observer-fade">
            <div class="container">
                <div class="flex justify-content-center align-items-center w--100">
                    <ul class="nav nav-pills shadow-none gap-2">
                        <li 
                            v-for="item in features" 
                            :key="item" 
                            class="nav-item pointer" 
                            :class="{ 'active': item === selectedTab }"
                            @click="setTab(item)"
                        >
                            <span 
                                class="nav-link text--capitalize" 
                                aria-current="page"
                            >
                                {{ item }}
                            </span>
                        </li>
                    </ul>
                </div>

                <div class="problems-grid">
                    <template v-if="integrationsDataCategory.length">
                        <span 
                            v-for="item in integrationsDataCategory" 
                            :key="item.name" 
                            class="problem-card" 
                            :style="{ maxWidth: `${integrationsDataCategory.length === 1 ? '50%' : ''}` }"
                        >
                            <div class="problem-icon">
                                <img :src="item.imageUrl" class="m-w-100" alt="integration image">
                            </div>

                            <div class="flex align-items-center w--100 gap-1">
                                <h3 class="problem-title">
                                    {{ item.name }}
                                </h3>
                                <span v-if="!item.active" class="tag--pink text--xs tag bold badge rounded-pill">
                                    Coming soon
                                </span>
                            </div>

                            <p class="problem-description">
                                {{ item.description }}
                            </p>
                        </span>
                    </template>
                    
                    <template v-else>
                        <p class="problem-description text-center">
                            Coming soon!
                        </p>
                    </template>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { integrationsData } from "@/utils/data";

export default {
    name: "ProductIntegrations",
    
    data() {
        return {
            features: ["calendar", "data collection", "time tracking"],
            selectedTab: "calendar",
            loading: false,
            integrationsData,
            integrationsDataCategory: integrationsData,
            observer: null,
        };
    },

    watch: {
        "selectedTab"(newVal) {
            if (newVal) {                
                this.integrationsDataCategory = this.integrationsData.filter(item => item.category.includes(newVal));
            } else {
                this.integrationsDataCategory = this.integrationsData;
            }
        },
    },

    async mounted() {
        if (this.selectedTab) {
            this.integrationsDataCategory = this.integrationsData.filter(item => item.category.includes(this.selectedTab));
        }
    },

    async mounted() {
        this.initPageIntersectionObserver();
    },

    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    },

    methods: {
        initPageIntersectionObserver() {
            this.observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("in-view");
                    }
                });
            }, {
                threshold: 0.1,
                rootMargin: "0px 0px -50px 0px",
            });

            // Observe all elements with observer-fade class
            document.querySelectorAll(".observer-fade").forEach(el => {                
                this.observer.observe(el);
            });
        },

        setTab(tab) {
            this.selectedTab = tab?.toLowerCase();
        },
    },
};
</script>

<style lang="scss" scoped>
.nav-item {
    transition: background-color .15s ease-in-out;
    --transition: background-color .15s ease-in-out;
    border-radius: 12px !important;
    border: 1px solid transparent;
}

.nav-link {
    transition: color .15s ease-in-out;
    --transition: color .15s ease-in-out;
}

.nav-item.active, .nav-item:hover {
    background: #faf9f5 !important;
    border: 1px solid #0891b2;

    .nav-link {
        color: #0891b2 !important;
        font-weight: 600;
    }
}

.problem-card {
    padding: 1rem 1.2rem;
}

.problems-grid {
    max-width: 70%;
    margin: auto;
    margin-top: 3rem;
}

.problem-title {
    font-size: 1rem;
    margin-bottom: 0px !important;
}

.problem-description {
    font-size: 0.875rem;
}

@media (max-width: 768px) {
    .nav.nav-pills {
        flex-direction: column;
    }

    .problems-grid {
        max-width: 100%;
    }

    .nav-item {
        display: flex;
        justify-content: center;
    }

    .problem-card {
        padding: 1rem;
    }

    .problem-description {
        font-size: 0.875rem;
    }
}

</style>